<template>
  <div class="card">
    <el-card class="view-card">
      <div slot="header" class="view-card-title">
        <div class="view-card-title-left">
          <span>
            <em v-if="textItem.is_must == '1'" style="color: red;margin-right: 5px">*</em>{{textIndex+1}}.{{textItem.type | getExamStyleCn}}
          </span>
        </div>
        <div class="view-card-title-right">
          <el-tooltip effect="dark" content="必填" placement="top">
            <el-checkbox class="cy_btn_i" v-model="textItem.is_must" true-label="1" false-label="0"></el-checkbox>
          </el-tooltip>
          <el-tooltip class="mover view-card-title-right-img" style="display: inline-block" effect="dark" content="按住拖动选项" placement="top">
            <div>
              <img class="cy_btn_i draggable_item colourless" src="@/assets/answerExam/drag0.svg" alt="" >
              <img class="cy_btn_i draggable_item color" src="@/assets/answerExam/drag1.svg" alt="" >
            </div>
          </el-tooltip>
          <el-tooltip class="view-card-title-right-del" style="display: inline-block" effect="dark" content="删除题目" placement="top">
            <i class="cy_btn_i el-icon-delete" @click="handleDelTest(textIndex)"></i>
          </el-tooltip>
        </div>
      </div>
      <div class="view-card-content">
        <div class="view-card-content-textName">
          <el-input type="text" v-model="textItem.case_problem" :placeholder="textItem.placeholder"></el-input>
        </div>
        <div class="view-card-content-select">
          <draggable v-model="textItem.choose_list" animation="300" group= "group_xzt" handle=".select-item-move" @end="onEnd">
            <transition-group tag="div">
              <template v-for="(option,index) in textItem.choose_list">
                <div class="view-card-content-select-item" :key="index">
                  <el-tooltip class="select-item-move" style="display: inline-block" effect="dark" content="按住拖动选项" placement="left">
                    <div>
                      <img class="colourless" src="@/assets/answerExam/operation_drag.svg" alt="">
                      <img class="color" src="@/assets/answerExam/operation_drag1.svg" alt="">
                    </div>
                  </el-tooltip>
                  <span class="select-item-radio">{{changeAbc(index)}}</span>
                  <el-input type="text" v-model="option.text" :placeholder="option.placeholder"></el-input>
                  <el-tooltip class="select-item-del" style="display: inline-block" effect="dark" content="删除选项" placement="top">
                    <div>
                      <img class="cy_btn_i colourless" src="@/assets/answerExam/option_delete.svg" alt="" @click="handleDel(index)">
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </transition-group>
          </draggable>
        </div>
        <div class="view-card-content-select-button">
          <el-button class="add_option_btn" @click.stop="handleAdd"><i class="el-icon-plus"></i>添加选项</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
export default {
  components: {
    draggable,
  },
  props: {
    textArray:{
      type:Array,
      default:function() {
        return []
      }
    },
    textItem:{
      type:Object,
      default:function() {
        return {}
      }
    },
    textIndex:{
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    onEnd:function(){
      this.textItem.choose_list.forEach((res,index) => {
        res.id = index+1;
        res.value = this.changeAbc(index);
      });
      console.log("this.textItem.choose_list======",this.textItem.choose_list)
    },
    handleDelTest:function(textIndex){
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.textArray.splice(textIndex,1);
        setTimeout(() => {
          this.$message.success('删除成功!');
        }, 200);
      }).catch(() => {
        setTimeout(() => {
          this.$message.info('已取消删除!');
        }, 200);
      });
    },
    changeAbc:function (index) {
      return String.fromCharCode(index+65)
    },
    handleAdd:function () {
      let obj ={};
      let index =this.textItem.choose_list.length + 1;
      console.log("indexhandleAdd==========",index)
      obj.id = index;
      obj.value = this.changeAbc(index-1);
      obj.text = "";
      obj.placeholder = "选项";
      this.textItem.choose_list.push(obj);
    },
    handleDel:function (index) {
      if(this.textItem.choose_list.length <= 2){
        this.$message.warning('最少保留两个选项!');
      }else{
        this.textItem.choose_list.splice(index,1);
      }
      this.textItem.choose_list.forEach((res,index) =>{
        res.id = index +1;
        res.value = this.changeAbc(index);
      })
      console.log("choose_list======",this.textItem.choose_list)
    }
  },
  computed:{

  },
  filters:{
    getExamStyleCn:function (val) {
      if(val == "XZT_DXT"){
        return "选择题";
      }else if(val == "XZT_DDXT"){
        return "多选题";
      }
    }
  }
};
</script>

<style lang='scss' scoped>
  ::v-deep .el-input__inner{
    height: 30px !important;
    &:hover{
      border: 1px dashed #DCDFE6;
    }
    border: 0px dashed #DCDFE6;
    &:focus-within{
      background-color: #f4f4f4;
    }
  }
  ::v-deep input::-webkit-input-placeholder {
    text-align: left;
    color: #555A64;
  }
  ::v-deep .el-card__body{
    padding: 0px 0px 0px 0px;
  }
  ::v-deep .el-checkbox__inner{
    border: 1px solid #afb0b2;
  }
  .cy_btn_i {
    margin-left: 10px;
    color: #afb0b2;
    font-size: 20px;
    cursor: pointer;
    vertical-align: middle;
  }
  .cy_btn_i:hover {
    color: #1e80ff;
  }


  .view-card{
    margin-top: 20px;
    border-radius: 3px;
    ::v-deep .el-card__header{
      height: 50px !important;
      padding: 0px 0px 0px 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #FAFBFC;
      .view-card-title{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .view-card-title-left{
          span{
            margin-left: 20px;
            font-size: 16px;
            font-weight: 400;
            color: #555A64;
          }
        }
        .view-card-title-right{
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .view-card-title-right-img{
            &:hover{
              .color{
                display: inline-block;
              }
              .colourless{
                display: none;
              }
            }
            .color{
              display: none;
            }
          }
          .view-card-title-right-del{
            margin-right: 10px;
          }
        }
      }

    }
    .view-card-content{
      display: flex;
      flex-flow: column nowrap;
      padding: 10px 0px 0px 20px;
      .view-card-content-textName{
        width: 520px;
        line-height: 1.43;
        text-align: left;
        font-size: 16px;
        margin-bottom: 10px;
      }
      .view-card-content-select{
        display: flex;
        flex-flow: column nowrap;
        width: 520px;
        .view-card-content-select-item{
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          &:hover{
            .colourless{
              display: inline-block;
            }
            ::v-deep .el-input__inner{
              border: 1px dashed #DCDFE6;
            }
          }
          .color{
            display: none;
          }
          .colourless{
            display: none;
          }
          .select-item-move{
            &:hover{
              .color{
                display: inline-block;
              }
              .colourless{
                display: none;
              }
            }
            width: 16px;
            height: 16px;
            cursor: pointer;
            img{
              width: 16px;
              height: 16px;
            }
            margin-right: 5px;
          }
          .select-item-del{
            margin-left: 10px;
          }
          .select-item-radio{
            height: 16px;
            margin-right: 5px;
            font-size: 16px;
            color: #555A64;
          }
        }
      }
      .view-card-content-select-button{
        margin-left: 20px;
        margin-bottom: 20px;
        .add_option_btn{
          i{
            margin-right: 10px;
            font-weight: 600;
            font-size: 15px;
          }
          display: flex;
          align-items: center;
          width: 120px;
          height: 36px;
          line-height: 36px;
          background: #F7F8FB;
          border-radius: 3px;
          font-size: 14px;
          color: #1E80FF;
          cursor: pointer;
          border: 0px;
          &:hover{
             border: 1px dashed #1E80FF;
             border-color: #1e80ff;
             background-color: rgba(30, 128, 255, 0.1);
          }
        }
      }
   }
  }

</style>
